/**
 * WHITE LABEL THEME (admin panel)
 * --------------------------------
 * Edit only this file to rebrand the admin: name, logos, favicon, links
 * and colors. Everything else reads from here.
 *
 *  - Images: put the files in ./assets and change the imports below,
 *    or use a full https:// URL instead of an import.
 *  - Colors: any CSS hex color (#rrggbb). They become CSS variables
 *    (e.g. colors.primary -> var(--theme-primary)) used by all styles.
 */
import { ConfigProvider } from "antd";
import logo from "./assets/logo.png"; // sidebar (open) and login page
import logoSmall from "./assets/logo-small.png"; // sidebar (collapsed)
import favicon from "./assets/favicon.ico";

const theme = {
  brand: {
    name: "AbyM",
    companyName: "AbyM Technology", // sidebar footer "Designed & Developed by"
    appTitle: "AbyM Technology ABHA Admin", // browser tab title
    logo,
    logoSmall,
    favicon,
    website: "https://abym.in",
    websiteLabel: "abym.in", // sidebar footer link text
    showDevelopedBy: true, // sidebar footer "Designed & Developed by ..."
    patientPortalUrl: "https://www.pathkindlabs.com/abha", // URL column in HIP tables
  },

  colors: {
    primary: "#1559a2", // headings, active items, charts
    secondary: "#20405f", // sidebar, dark panels
    accent: "#fecc4e", // yellow buttons, icons, loader
    accentDark: "#f59e0b", // selected menu item, highlights
    link: "#1890ff", // links and antd controls (buttons, inputs, pagination)
  },
};

/* ── Below here: applies the theme, no need to edit ─────────────────── */

const kebab = (s) => s.replace(/[A-Z]/g, (c) => "-" + c.toLowerCase());

export const hexToRgb = (hex) => {
  let h = String(hex || "").replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  return Number.isNaN(n) ? "0, 0, 0" : `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
};

/** Call once before rendering: CSS variables, antd colors, title, favicon. */
export const applyTheme = () => {
  const root = document.documentElement;
  Object.entries(theme.colors).forEach(([name, value]) => {
    root.style.setProperty(`--theme-${kebab(name)}`, value);
    root.style.setProperty(`--theme-${kebab(name)}-rgb`, hexToRgb(value));
  });

  // antd 4 colors (needs antd.variable.min.css, imported in index.js)
  ConfigProvider.config({
    theme: { primaryColor: theme.colors.link, errorColor: "#ff4d4f" },
  });

  document.title = theme.brand.appTitle || theme.brand.name;
  setLink("icon", theme.brand.favicon);
  setLink("apple-touch-icon", theme.brand.logoSmall || theme.brand.favicon);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.content = theme.colors.primary;
};

export default theme;
